import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';

export const DashboardLayout = () => {
    return (
        <div className="min-h-screen bg-surface-app">
            <Sidebar />
            <main className="ml-64 min-h-screen">
                <Outlet />
            </main>
            <Toaster 
                position="top-right"
                toastOptions={{
                    style: {
                        background: '#121212',
                        border: '1px solid #27272A',
                        color: '#FFFFFF',
                    },
                }}
            />
        </div>
    );
};

export default DashboardLayout;
